// Whether the main menu swaps its stock keyart for the player's
// chosen profile background. Toggled from the Edit Profile modal,
// read by the hub, persisted across restarts. A tiny subscription
// store (same shape as uiScale.js) because the hub stays mounted
// under the profile overlay and has to repaint the moment the
// toggle flips.
const KEY = 'valkenhall:hubProfileBackground';
const listeners = new Set();

export function getHubProfileBg() {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function setHubProfileBg(on) {
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch {}
  for (const fn of listeners) fn(on);
}

export function onHubProfileBgChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
